import { writable } from 'svelte/store';

let nextId = 1;

function createToastStore() {
	const { subscribe, update } = writable([]);

	function show({ kind = 'info', message, action = null, durationMs = 5000 }) {
		const id = nextId++;
		const toast = { id, kind, message, action };
		update((list) => [...list, toast]);
		if (durationMs > 0) {
			setTimeout(() => dismiss(id), durationMs);
		}
		return id;
	}

	function dismiss(id) {
		update((list) => list.filter((t) => t.id !== id));
	}

	function clear() {
		update(() => []);
	}

	return {
		subscribe,
		show,
		dismiss,
		clear
	};
}

export const toastStore = createToastStore();
